import { Link } from "react-router-dom";
import { LockClosedIcon } from "@heroicons/react/24/outline";
import { useLanguage } from "../../../contexts/LanguageContext";
import { useStore } from "../../../contexts/StoreContext";

// Sneak peek of a tab the plan does not include (decision K4=B): the real tab
// components render sample data underneath, blurred, hidden from assistive
// tech and unfocusable (`inert`), with one real number on the card above.
export default function LockedPreview({ title, body, upgradeLabel, children }) {
  const { t } = useLanguage();
  const { canManageStore } = useStore();

  return (
    <div className="relative overflow-hidden rounded-[14px]">
      <div
        aria-hidden="true"
        inert
        data-testid="locked-preview-sample"
        className="pointer-events-none select-none opacity-70 blur-[3px]"
      >
        {children}
      </div>
      <div className="absolute inset-0 flex items-start justify-center bg-[#F6F7F9]/40 px-4 pt-10 sm:pt-16">
        <div
          role="region"
          aria-label={title}
          className="flex w-full max-w-md flex-col gap-4 rounded-[14px] border border-indigo-200 bg-white p-6 shadow-lg"
        >
          <div className="flex items-center justify-between gap-3">
            <span className="flex h-9 w-9 items-center justify-center rounded-[10px] bg-indigo-50 text-indigo-700">
              <LockClosedIcon className="h-5 w-5" aria-hidden="true" />
            </span>
            <span className="rounded-full bg-gray-100 px-2.5 py-0.5 text-xs font-semibold text-gray-600">
              {t("dashboard.locked.sampleData")}
            </span>
          </div>
          <div className="flex flex-col gap-2">
            <h2 className="text-lg leading-snug font-semibold text-gray-900">{title}</h2>
            <p className="text-sm leading-relaxed text-gray-700">{body}</p>
          </div>
          {canManageStore ? (
            <Link
              to="/pricing"
              className="inline-flex min-h-11 items-center justify-center self-start rounded-[10px] bg-indigo-600 px-5 text-sm font-semibold text-white hover:bg-indigo-700"
            >
              {upgradeLabel}
            </Link>
          ) : (
            <p className="text-sm text-gray-600">{t("dashboard.locked.askOwner")}</p>
          )}
        </div>
      </div>
    </div>
  );
}
